import axios from "axios";
const state = {
    sucursales:[]
};
const getters = {};

const actions = {
    getSucursales( {commit} ){
        axios
        .get("https://torstdio.site/api/v1/sucursal/all")
        .then(response => {
            commit('setSucursales', response.data);
        });
    }
};

const mutations = {
    setSucursales(state, data){
        state.sucursales = data;
    }
};

export default{
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}